import { ONBOARDING_PAGES } from "core/consts";
import Translations from "translations/types";

export type StepperStep =
  | typeof ONBOARDING_PAGES.ACCOUNT
  | typeof ONBOARDING_PAGES.ADDITIONAL_INFORMATION
  | typeof ONBOARDING_PAGES.COMPANY
  | typeof ONBOARDING_PAGES.PASSWORD
  | typeof ONBOARDING_PAGES.SERVICES
  | typeof ONBOARDING_PAGES.PASSWORD_RESET;

export type StepperStepPersonalOnboarding =
  | typeof ONBOARDING_PAGES.ACCOUNT
  | typeof ONBOARDING_PAGES.PASSWORD;

export type StepperStepCompanyOnboarding =
  | typeof ONBOARDING_PAGES.YOUR_COMPANY
  | typeof ONBOARDING_PAGES.YOUR_TEAM;

export type Step =
  | StepperStep
  | typeof ONBOARDING_PAGES.CONGRATULATIONS
  | typeof ONBOARDING_PAGES.WELCOME
  | typeof ONBOARDING_PAGES.PASSWORD_RESET;

export const STEPS: Array<Step> = [
  ONBOARDING_PAGES.WELCOME,
  ONBOARDING_PAGES.COMPANY,
  ONBOARDING_PAGES.SERVICES,
  ONBOARDING_PAGES.ADDITIONAL_INFORMATION,
  ONBOARDING_PAGES.ACCOUNT,
  ONBOARDING_PAGES.PASSWORD,
  ONBOARDING_PAGES.CONGRATULATIONS,
  ONBOARDING_PAGES.PASSWORD_RESET,
];

export const STEPPER_STEPS: Array<StepperStep> = [
  ONBOARDING_PAGES.COMPANY,
  ONBOARDING_PAGES.SERVICES,
  ONBOARDING_PAGES.ADDITIONAL_INFORMATION,
  ONBOARDING_PAGES.ACCOUNT,
  ONBOARDING_PAGES.PASSWORD,
];

const STEPPER_STEPS_PERSONAL: Array<StepperStepPersonalOnboarding> = [
  ONBOARDING_PAGES.ACCOUNT,
  ONBOARDING_PAGES.PASSWORD,
];

const STEPPER_STEPS_COMPANY: Array<StepperStepCompanyOnboarding> = [
  ONBOARDING_PAGES.YOUR_COMPANY,
  ONBOARDING_PAGES.YOUR_TEAM,
];

const ONBOARDING_TYPE_PERSONAL = "personalOnboarding";
const ONBOARDING_TYPE_COMPANY = "companyOnboarding";

export function getStepperSteps(
  translations: Translations,
  onboardingType?: string,
): Array<{ key: string; value: string }> {
  switch (onboardingType) {
    case ONBOARDING_TYPE_PERSONAL:
      return STEPPER_STEPS_PERSONAL.map((step) => ({
        key: step,
        value: translations.newOnboardingTwo.stepper[step],
      }));
    case ONBOARDING_TYPE_COMPANY:
      return STEPPER_STEPS_COMPANY.map((step) => ({
        key: step,
        value: translations.newOnboardingTwo.stepper[step],
      }));
    default:
      return STEPPER_STEPS.map((step) => {
        let newStep = step;
        // Display the password reset component on the Account page step where they initially triggered the password reset,
        // without creating a dedicated step for it
        if (newStep === ONBOARDING_PAGES.PASSWORD_RESET) {
          newStep = ONBOARDING_PAGES.ACCOUNT;
        }

        return {
          key: newStep,
          value:
            translations.newOnboardingTwo.stepper[
              newStep === "additional-information"
                ? "additionalinformation"
                : newStep
            ],
        };
      });
  }
}
